import axios from "axios";
import { Component } from "react";
import { Button, Card, Col, Form, Modal, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import DatePicker from 'react-datepicker';
import { validateAssignProjectForm } from "../../utils/validation";
import { DateTimeFormat } from "../DateFormat/DateTimeFormat";
import CommonToast from "../Toaster/CommonToast";
import CommonLoader from "../loaderComponent/CommonLoader";
export default class AssignProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: this.props.location.state?.userId || null,
      userName: this.props.location.state?.userName || "Unknown",
      completed: '',
      projects: [],
      loading: false,
      selectedProjectId: '',
      hasError: false,
      errMsg: "",
      startDate: null,
      endDate: '',
      selectedDate: '',
      selectedProject: '',
      assignedProjectToEmployee: [],
      message: '',
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: ''
    };
    console.log("satte", this.state);
  }

  async componentDidMount() {
    this.fetchAssignedProjectToEmp();
    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const response = await axios.get('/project', { headers });
      console.log("response", response);
      this.setState({ projects: response?.data, loading: false });

    } catch (error) {
      console.error("Error fetching project:", error);
      let errorMessage = "Failed to load project.";
      if (error.response && error.response.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  }

  pushProjectList = () => {
    let projectList = [];
    this.state.projects.map((project, index) => {
      projectList.push(
        <option key={index} value={project.id}>
          {project.name}
        </option>
      );
    });
    return projectList;
  };
  // handleProjectChange = (e) => {
  //   this.setState({ selectedProjectId: e.target.value });
  // };
  handleProjectChange = (event) => {
    const { name, value } = event.target;
    let errors = { ...this.state.errors };

    this.setState({ [name]: value });

    if (!value) {
      errors[name] = "Project selection is required";
    } else {
      delete errors[name];
    }

    this.setState({ errors });
  };


  openModal = (project, index) => {
    console.log("project", project);
    console.log("index", index);
    this.setState({ selectedProject: { ...project, index }, showModal: true });
  };

  // Close modal
  closeModal = () => {
    this.setState({ showModal: false, selectedProject: null, endDate: null });
  };

  handleDateChange = (date, field) => {
    let errors = { ...this.state.errors };
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    if (field === "startDate") {
      if (!date) {
        errors.startDate = "Start date is required.";
      } else if (date < firstDayOfMonth) {
        errors.startDate = "Start date cannot be from a past month.";
      } else {
        delete errors.startDate;
      }

      // Reset endDate when startDate is changed
      this.setState({
        startDate: date,
        endDate: null,
        errors,
      });
    }

    if (field === "endDate") {
      if (!date) {
        errors.endDate = "End date is required.";
      } else if (date <= firstDayOfMonth) {
        errors.endDate = "End date must be in the future.";
      }
      // else if (this.state.startDate && date <= this.state.startDate) {
      //   errors.endDate = "End date cannot be before or the same as Start Date.";
      // } 
      else {
        delete errors.endDate;
      }

      this.setState({
        endDate: date,
        errors,
      });
    }
  };
  formatDate = (date) => {
    return date ? new Date(date).toLocaleDateString('en-CA') : null;
  };

  onSubmit = async (e) => {
    e.preventDefault();
    this.setState({ hasError: false, errorMsg: "", completed: false, loading: true });
    const errors = validateAssignProjectForm(
      this.state.selectedProjectId,
      this.state.startDate
    );
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }

    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    try {
      const assignProjectPayload = {
        userId: this.state.userId,
        projectId: this.state.selectedProjectId,
        startDate: this.formatDate(this.state.startDate),
      };
      const userResponse = await axios.post("/employeeProject/assign", assignProjectPayload, { headers });
      this.setState({ message: userResponse?.data?.message });
      this.setState({
        completed: true,
        toastMessage: userResponse?.data?.message,
        toastVariant: 'success',
        showModal: false,
        color: 'green',
        showToast: true,
      },
        () => {
          this.setState({
            selectedProjectId: "",
            startDate: "",
            errors: {},
          });
        }
      );


      setTimeout(() => {
        this.setState({
          loading: false, showToast: false,

        });
      }, 1000);
      if (this.state.completed) {
        this.fetchAssignedProjectToEmp();
      }
    } catch (error) {
      console.log('error', error);
      this.setState({
        hasError: true,
        errMsg: error.response?.data?.error || "Something went wrong",
        toastMessage: error.response?.data?.error || "Something went wrong",
        toastVariant: 'danger',
        color: 'red',
        showToast: true
      });
      setTimeout(() => {
        this.setState({
          loading: false, showToast: false,
          selectedProjectId: "",
          startDate: "",
          errors: {},
        });
      }, 1000);

      window.scrollTo(0, 0);
    }
  };

  fetchAssignedProjectToEmp = () => {
    this.setState({ loading: true });
    const userId = this.state.userId;
    axios({
      method: 'get',
      url: `employeeProject/${userId}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        console.log("today", res.data?.employeeProjects);
        this.setState({ assignedProjectToEmployee: res.data.employeeProjects, loading: false });
      })
      .catch(err => {
        this.setState({ loading: false });
        console.log("error is here", err);
      });
  };



  deleteProject = async (id, index) => {
    const { userId, endDate, selectedProject, errors, startDate } = this.state;
    if (!endDate) {
      this.setState({ errors: { ...errors, endDate: "Please select an end date before deleting." } });
      return;
    }
    if (endDate < startDate) {
      this.setState({ errors: { ...errors, endDate: "End date cannot be before Start Date." } });
      return;
    }
    if (errors.endDate) {
      // message.error(errors.endDate);
      return;
    }

    try {
      const projectDeletePayload = {
        userId,
        projectId: selectedProject?.projectId,
        endDate
      };

      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json"
      };

      const res = await axios.put("employeeProject/remove", projectDeletePayload, { headers });

      if (res.status === 200) {
        this.setState({
          completed: true,
          toastMessage: res?.data?.message,
          toastVariant: "success",
          showModal: false,
          color: "green",
          showToast: true,
        });

        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
        }, 2000);

        this.fetchAssignedProjectToEmp();
      }
    } catch (error) {
      this.setState({
        hasError: true,
        errMsg: "Failed to delete project. Please try again",
        toastMessage: "Project not deleted!",
        toastVariant: "danger",
        color: "red",
        showToast: true,
      });

      // message.error("Failed to delete project. Please try again.");

      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
      }, 900);

      console.error("Error deleting project:", error);
    }
  };



  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/employee-list");
      this.setState({ loading: false });
    }, 500);
  };
  render() {
    return (
      <div className="pt-4">
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={this.state.loading}>
          < >
            <Card className="shadow-sm rounded border-0">
              <Card.Header className="text-white">
                <strong>  Assign Project
                </strong>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={this.onSubmit}>
                  {/* <Card className="col-sm-12 main-card">
              
                <Card.Body> */}
                  <div className="row">
                    <div className="col-sm-12">

                      <Row className="mb-3">
                        <Col xs={12} md={4} lg={4}>
                          <Form.Group controlId="formUserId">
                            <Form.Label className="text-muted required">
                              User Id
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="userId"
                              value={this.state.userId}
                              readOnly
                              required
                            />
                          </Form.Group>
                        </Col>
                        <Col xs={12} md={4} lg={4}>
                          <Form.Group controlId="formProject">
                            <Form.Label className="text-muted required">
                              Assign To
                            </Form.Label>
                            <Form.Control
                              as="select"
                              className="form-select"
                              value={this.state.selectedProjectId}
                              onChange={this.handleProjectChange}
                              name="selectedProjectId"

                            >
                              <option value="" defaultValue disabled>
                                Choose Project...
                              </option>
                              {this.pushProjectList()}
                            </Form.Control>
                          </Form.Group>
                          <span className="login-error">
                            {this.state.errors.selectedProjectId && (
                              <small className="text-danger">{this.state.errors.selectedProjectId}</small>
                            )}
                          </span>
                        </Col>
                        <Col xs={12} md={4} lg={4}>
                          <Form.Group>
                            <Form.Label className="text-muted required">Start Date </Form.Label><br />
                            <DatePicker
                              selected={this.state.startDate}
                              className="form-control"
                              dateFormat="dd/MM/yyyy"
                              onChange={date => this.handleDateChange(date, 'startDate')}
                              placeholderText="Select start date"
                              minDate={new Date(new Date().getFullYear(), new Date().getMonth(), 1)}
                            />

                          </Form.Group>
                          <span className="login-error">
                            {this.state.errors.startDate && <small className="text-danger">{this.state.errors.startDate}</small>}
                          </span>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <div className='add-cancel-btn '>
                    <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" type="submit" >
                      Assign
                    </Button>
                    <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={this.handleBack}>Cancel</Button>
                  </div>
                </Form>
              </Card.Body >
            </Card >
          </ >
        </CommonLoader >
        <Table striped bordered hover responsive className="mt-3 shadow-sm custom-assign-table">
          <thead className="table-primary text-center">
            <tr>
              <th>User Id</th>
              <th>Project Name</th>
              <th>Start Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {this.state.assignedProjectToEmployee.length > 0 ? (
              this.state.assignedProjectToEmployee.map((doc, index) =>
              (
                <tr key={index} className="text-center align-middle">
                  {
                    console.log("harsh", doc.startDate)
                  }
                  <td>{doc.id}</td>
                  <td>{doc.project.name}</td>
                  <td>{doc.startDate ? DateTimeFormat(doc.startDate) : "N/A"}</td>
                  <td>

                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id={`tooltip-edit-${doc.id}`}>Delete Project</Tooltip>}
                    >
                      <Button size="sm" onClick={() => this.openModal(doc, index)} variant="outline-danger" className="delete-btn">
                        <i className="fas fa-trash"></i>
                      </Button>
                    </OverlayTrigger>

                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center text-muted py-3">
                  <i className="fas fa-info-circle me-2 text-secondary"></i>
                  No projects assigned.
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        <Modal show={this.state.showModal} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title style={{ color: 'red' }}>Confirm Deletion</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="text-muted required">Select an end date before deleting the project:{this.selectedProject}</p>
            <DatePicker
              selected={this.state.endDate}
              className="form-control"
              dateFormat="dd/MM/yyyy"
              onChange={date => this.handleDateChange(date, 'endDate')}
              placeholderText="Select end date"
              minDate={this.state.startDate || ''}
              isClearable
            />
            <span className="login-error">
              {this.state.errors.endDate && <small className="text-danger">{this.state.errors.endDate}</small>}
            </span>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-primary" onClick={this.closeModal}>
              Cancel
            </Button>
            <Button variant="outline-danger" onClick={this.deleteProject}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
